"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureNumberFormat = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./typings"), exports);
var MeasureNumberFormat_1 = require("./MeasureNumberFormat");
Object.defineProperty(exports, "MeasureNumberFormat", { enumerable: true, get: function () { return MeasureNumberFormat_1.MeasureNumberFormat; } });
//# sourceMappingURL=index.js.map